import React from 'react';
import { Outlet } from 'react-router-dom';
import { MaintenanceArea } from './areas';
import NoticeList from './NoticeList';
import UnavailableView from './UnavailableView';
import { useMaintenance } from './useMaintenance';

interface MaintenanceGateProps {
  area: MaintenanceArea;
  /** Wrapped content. Omit to use the gate as a route layout (renders the matched child route). */
  children?: React.ReactNode;
}

/**
 * Guards one area of the site. While a window blocks the area (its own, or a
 * whole-product one) only this page's content is replaced by an unavailable
 * view; otherwise active banners and upcoming notices for the area show above
 * the page and the page works. Fails open while loading or if the status
 * check fails.
 */
const MaintenanceGate: React.FC<MaintenanceGateProps> = ({ area, children }) => {
  const view = useMaintenance(area);

  if (view.blocked) {
    return (
      <UnavailableView
        blocking={view.blocking}
        expectedBackAt={view.expectedBackAt}
        area={area}
        onRetry={view.refresh}
      />
    );
  }

  return (
    <>
      <NoticeList notices={[...view.banners, ...view.upcoming]} />
      {children ?? <Outlet />}
    </>
  );
};

export default MaintenanceGate;
